import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./incomelist.css";
import { Player } from "@lottiefiles/react-lottie-player";

function Incomelist() {
  const [incomeData, setIncomeData] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [editFormData, setEditFormData] = useState({});

  useEffect(() => {
    const fetchIncome = async () => {
      try {
        const res = await axios.get(
          `${INVENTORY_API_BASE_URL}/api/income`
        );
        setIncomeData(res.data);
      } catch (error) {
        console.error("Error fetching income data:", error);
      }
    };

    fetchIncome();
  }, []);

  const handleEditClick = (index) => {
    setEditIndex(index);
    const selected = incomeData[index];
    setEditFormData({
      ...selected,
      date: selected.date?.slice(0, 10),
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = async (id) => {
    try {
      await axios.put(
        `${INVENTORY_API_BASE_URL}/api/income/${id}`,
        editFormData
      );
      const updatedData = [...incomeData];
      updatedData[editIndex] = { ...editFormData, _id: id };
      setIncomeData(updatedData);
      setEditIndex(null);
    } catch (error) {
      console.error("Error updating income:", error);
      alert("Update failed.");
    }
  };

  const handleCancel = () => {
    setEditIndex(null);
    setEditFormData({});
  };

  return (
    <div className="incomelist-container">
      <h2 style={{ fontWeight: "bold", marginBottom: "1rem" }}>
        All Income Entries
      </h2>

      {incomeData.length === 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "40px",
            color: "#6c757d",
            fontFamily: "Segoe UI, sans-serif",
          }}
        >
          <Player
            autoplay
            loop
            src="https://assets10.lottiefiles.com/packages/lf20_qp1q7mct.json"
            style={{ height: "220px", width: "220px" }}
          />
          <p style={{ fontSize: "18px", fontWeight: "600", marginTop: "10px" }}>
            No income records found
          </p>
        </div>
      ) : (
        <table className="income-table">
          <thead>
            <tr>
              <th style={{ textAlign: "center" }}>Amount</th>
              <th style={{ textAlign: "center" }}>Category</th>
              <th style={{ textAlign: "center" }}>Source</th>
              <th style={{ textAlign: "center" }}>Description</th>
              <th style={{ textAlign: "center" }}>Date</th>
              <th style={{ textAlign: "center" }}>Edit</th>
            </tr>
          </thead>
          <tbody>
            {incomeData.map((item, index) => (
              <tr key={item._id || index}>
                {editIndex === index ? (
                  <>
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="number"
                        name="amount"
                        value={editFormData.amount || ""}
                        onChange={handleInputChange}
                      />
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="text"
                        name="category"
                        value={editFormData.category || ""}
                        onChange={handleInputChange}
                      />
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="text"
                        name="source"
                        value={editFormData.source || ""}
                        onChange={handleInputChange}
                      />
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="text"
                        name="description"
                        value={editFormData.description || ""}
                        onChange={handleInputChange}
                      />
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="date"
                        name="date"
                        value={editFormData.date || ""}
                        onChange={handleInputChange}
                      />
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <button
                        className="save-button"
                        onClick={() => handleUpdate(item._id)}
                      >
                        Save
                      </button>
                      <button className="cancel-button" onClick={handleCancel}>
                        Cancel
                      </button>
                    </td>
                  </>
                ) : (
                  <>
                    <td style={{ textAlign: "center" }}>{item.amount}</td>
                    <td style={{ textAlign: "center" }}>{item.category}</td>
                    <td style={{ textAlign: "center" }}>{item.source}</td>
                    <td style={{ textAlign: "center" }}>{item.description}</td>
                    <td style={{ textAlign: "center" }}>
                      {new Date(item.date).toLocaleDateString()}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <button
                        className="edit-button"
                        onClick={() => handleEditClick(index)}
                      >
                        Edit
                      </button>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default Incomelist;
